package com.havn.app.features.clients.domain

data class Client(
    val id: String,
    val agentId: String,
    val firstName: String? = null,
    val lastName: String? = null,
    val fullName: String,
    val email: String? = null,
    val phone: String? = null,
    val qrToken: String,
    val walletPassKey: String,
    val notes: String? = null,
    val avatarDataUrl: String? = null,
    val avatarContentType: String? = null,
    val createdAt: String? = null,
    val updatedAt: String? = null,
    val openings: List<ClientOpening> = emptyList()
) {
    val contactLine: String
        get() = listOfNotNull(phone?.takeIf { it.isNotBlank() }, email?.takeIf { it.isNotBlank() })
            .joinToString(" · ")
            .ifBlank { "No contact captured" }

    val qrPayload: String
        get() = HavnClientQrPayload.forClient(id, walletPassKey).encode()
}

data class ClientDraft(
    val firstName: String,
    val lastName: String,
    val email: String? = null,
    val phone: String? = null,
    val notes: String? = null
) {
    val fullName: String
        get() = listOf(firstName, lastName).joinToString(" ").trim()
}

data class ClientOpening(
    val leadId: String,
    val openingId: String,
    val propertyId: String,
    val propertyTitle: String,
    val propertyAddress: String,
    val propertyPhotoDataUrl: String? = null,
    val openingTitle: String?,
    val startsAt: String,
    val status: String,
    val temperature: String
) {
    val displayTitle: String
        get() = openingTitle?.takeIf { it.isNotBlank() } ?: propertyTitle
}
